module.exports = __webpack_public_path__ + "static/media/UZ.676bb9f6.png";